import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login-layout',
    templateUrl: './login-layout.component.html'
})
export class LoginLayoutComponent implements OnInit {
    constructor(
        private router: Router
    ) { }

    ngOnInit() { }
 }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/login-layout/login-layout.component.ts